"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLogger = void 0;
class BaseLogger {
    getLogData() {
        return {
            [this.getLogType()]: this.constructor.name,
            ...this.getLogPayload(),
            ...this.getAdditionalLogContext(),
            timestamp: new Date().toISOString(),
        };
    }
    printLog() {
        const className = this.constructor.name;
        const logData = this.getLogData();
        console.log(`[DEBUG] ${className}:`, JSON.stringify(logData, null, 2));
    }
    getAdditionalLogContext() {
        return {};
    }
}
exports.BaseLogger = BaseLogger;
